module.exports = __webpack_public_path__ + "img/Calendar.1460fe9.svg";